import { createContext, useCallback, useContext, useState, type ReactNode } from 'react'

interface RightPanelContextType {
  /** AccountId der aktuell angezeigten Firma (oder null) */
  firmaAccountId: string | null
  firmaName: string | null
  /** Page registriert die aktuelle Firma */
  setFirma: (accountId: string, name: string) => void
  /** Page entfernt die Firma (bei Unmount) */
  clearFirma: () => void
}

const RightPanelContext = createContext<RightPanelContextType | null>(null)

export function RightPanelProvider({ children }: { children: ReactNode }) {
  const [firmaAccountId, setFirmaAccountId] = useState<string | null>(null)
  const [firmaName, setFirmaName] = useState<string | null>(null)

  const setFirma = useCallback((accountId: string, name: string) => {
    setFirmaAccountId(accountId)
    setFirmaName(name)
  }, [])

  const clearFirma = useCallback(() => {
    setFirmaAccountId(null)
    setFirmaName(null)
  }, [])

  return (
    <RightPanelContext.Provider value={{ firmaAccountId, firmaName, setFirma, clearFirma }}>
      {children}
    </RightPanelContext.Provider>
  )
}

export function useRightPanel() {
  const ctx = useContext(RightPanelContext)
  if (!ctx) throw new Error('useRightPanel must be inside <RightPanelProvider>')
  return ctx
}
